module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Anchor-center-down-00debae132d52ba65c94c16e413b2f06.svg";